module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main